const usePageProvider = ({ page }) => {
	return {
		pageName: page
	};
};

export default usePageProvider;
